import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import EmailModel from "../../models/email";

export default class EmailRepository extends BaseRepository {
  static modelClass = EmailModel;
  modelName = "email";
}
